<template>
    <div class="v-box-date-box4">
        <h1 class="animated fadeInLeft">
            {{ option.title }}
            <span v-if="!['',null,undefined].includes(option.progress)">
                (进度：
                <avue-count-up :end="option.progress | percentageF(option)" />%)
            </span>
        </h1>
        <div class="box">
            <div class="animated bounceIn left">
                <h1>
                    <avue-count-up
                        :end="option.total"
                        :start="
                            option.total - 100 < 0 ? option.total : option.total - 100
                        "
                    />
                </h1>
                <h2>总计</h2>
            </div>
            <div class="animated bounceIn right">
                <div v-for="(item, i) in option.data" :key="i" class="progress">
                    <div>{{ item.label }}</div>
                    <div>
                        <el-progress
                            :percentage="item.value | percentageF(option)"
                            :color="item.color"
                            :format="() => item.value || '0'"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "VBoxDateBox4",
    props: {
        option: {
            type: Object,
            default: () => ({}),
        },
    },
    filters: {
        percentageF(value, option) {
            let num = Math.round((value / option.total) * 100);
            return isNaN(num) ? 0 : num
        }
    }
};
</script>

<style lang="scss" scoped>
.v-box-date-box4 {
    background-color: #fff;
    padding: 1.5rem 1rem 1rem 1.5rem;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 0 0.5rem #ccc;
    &:hover {
        box-shadow: 0 0 0.8rem #888;
    }
    > h1 {
        font-size: 1rem;
    }
    .box {
        display: flex;
        flex-flow: row;
        margin-top: 10px;
        height: 100px;
        > div {
            flex: 1;
            min-height: 75px;
            &:first-child {
                text-align: center;
                margin-top: 0.1rem;
                h1 {
                    font-size: 2rem;
                    margin: auto;
                }
                h2 {
                    font-size: 1rem;
                }
            }
            .progress {
                display: flex;
                flex-flow: row;
                margin-bottom: 0.5rem;
                > div {
                    &:first-child {
                        padding-right: 10px;
                        font-size: 0.7rem;
                    }
                    &:last-child {
                        flex: 1;
                    }
                }
            }
        }
        .left {
            flex: 0 0 30%;
            padding-right: 10px;
        }
        .right {
            display: flex;
            flex-direction: column;
            justify-content: space-around;
        }
    }
}
</style>
